/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssistantChatPostRequestMessage } from './AssistantChatPostRequestMessage';
import {
    AssistantChatPostRequestMessageFromJSON,
    AssistantChatPostRequestMessageFromJSONTyped,
    AssistantChatPostRequestMessageToJSON,
    AssistantChatPostRequestMessageToJSONTyped,
} from './AssistantChatPostRequestMessage';

/**
 * 
 * @export
 * @interface AssistantLoadConversationGet200Response
 */
export interface AssistantLoadConversationGet200Response {
    /**
     * 
     * @type {Array<AssistantChatPostRequestMessage>}
     * @memberof AssistantLoadConversationGet200Response
     */
    messages: Array<AssistantChatPostRequestMessage>;
}

/**
 * Check if a given object implements the AssistantLoadConversationGet200Response interface.
 */
export function instanceOfAssistantLoadConversationGet200Response(value: object): value is AssistantLoadConversationGet200Response {
    if (!('messages' in value) || value['messages'] === undefined) return false;
    return true;
}

export function AssistantLoadConversationGet200ResponseFromJSON(json: any): AssistantLoadConversationGet200Response {
    return AssistantLoadConversationGet200ResponseFromJSONTyped(json, false);
}

export function AssistantLoadConversationGet200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistantLoadConversationGet200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'messages': ((json['messages'] as Array<any>).map(AssistantChatPostRequestMessageFromJSON)),
    };
}

export function AssistantLoadConversationGet200ResponseToJSON(json: any): AssistantLoadConversationGet200Response {
    return AssistantLoadConversationGet200ResponseToJSONTyped(json, false);
}

export function AssistantLoadConversationGet200ResponseToJSONTyped(value?: AssistantLoadConversationGet200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'messages': ((value['messages'] as Array<any>).map(AssistantChatPostRequestMessageToJSON)),
    };
}

